import { useLocationBreadcrumbCapture } from '@/hooks/useLocationBreadcrumbCapture'

export default function LocationBreadcrumbCapture() {
    useLocationBreadcrumbCapture()
    return null
}
